<template>
  <b-row>
    <b-col cols="12">
      <b-breadcrumb :items="treeRoutes" @click="linkToDir($event)" />
    </b-col>
    <b-col cols="12">
      <b-row class="text-center">
        <slot v-if="records.length">
          <template v-for="(record,i) in records">
            <b-col
              :key="i"
              lg="2"
              md="3"
              sm="6"
              class="box-element item-list-view animated fadeIn"
              @dblclick="openDir(record)"
            >
              <b-dropdown
                size="sm"
                dropleft
                variant="light"
                class="m-0 icon-options-item"
                no-caret
                v-if="showButtons"
              >
                <template slot="button-content">
                  <font-awesome-icon icon="ellipsis-v"></font-awesome-icon>
                </template>
                <div v-if="record.typeRec == 'dirs'">
                  <b-dropdown-item @click="changeName(record)">Cambiar Nombre</b-dropdown-item>
                  <b-dropdown-item
                    v-if="record.estatus == 'ACTIVO'"
                    @click="removeDir(record)"
                  >Eliminar</b-dropdown-item>
                  <b-dropdown-item
                    v-if="record.estatus == 'INACTIVO'"
                    @click="restoreDir(record)"
                  >Restore</b-dropdown-item>
                </div>
                <div v-else>
                  <b-dropdown-item @click="changeNameMat(record)">Cambiar Nombre</b-dropdown-item>
                  <b-dropdown-item
                    v-if="record.estatus == 'ACTIVO'"
                    @click="removeMat(record)"
                  >Eliminar</b-dropdown-item>
                  <b-dropdown-item
                    v-if="record.estatus == 'ACTIVO'"
                    @click="editarMat(record)"
                  >Editar</b-dropdown-item>
                  <b-dropdown-item
                    v-if="record.estatus == 'INACTIVO'"
                    @click="restoreMat(record)"
                  >Restore</b-dropdown-item>
                </div>
              </b-dropdown>
              <font-awesome-icon v-if="record.typeRec == 'dirs' " icon="folder" class="icon-dir" />
              <font-awesome-icon v-else icon="file-invoice" class="icon-mat" />

              <span
                class="d-block text-center"
                v-b-popover.hover.bottom="record.name"
                variant="primary"
              >{{record.name}}</span>
            </b-col>
          </template>
        </slot>
        <slot v-else>
          <b-col class="empty-folder animated fadeIn">
            <font-awesome-icon icon="folder" class="icon-dir" />
            <p>La Carpeta Esta Vacía</p>
          </b-col>
        </slot>
      </b-row>
    </b-col>
  </b-row>
</template>
<script>
var author = {
  nombreUsuario: "Juan López",
  email: "juan@email.com"
};
import DirectorioService from "@/services/directorio.service";
import MaterialService from "@/services/material.service";

export default {
  name: "BreadDirectoriosContent",
  props: {
    treeRoutes: {
      type: Array,
      default: () => {
        return new Array();
      }
    },
    records: {
      type: Array,
      default: () => {
        return new Array();
      }
    },
    showButtons: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {};
  },
  methods: {
    openDir(dir) {
      if (dir.typeRec == "dirs") this.$emit("loadDataDirectorio", dir);
      else this.$router.push({ name: "Preview", params: { id: dir._id } });
    },
    linkToDir(link) {
      if (link.target.rel) this.$emit("return-dir", link.target.rel);
    },
    removeDir(dir) {
      this.$swal
        .fire({
          text: "¿Está Seguro de Eliminar el Directorio?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#285c4d",
          cancelButtonColor: "#aaa",
          confirmButtonText: "Sí, Eliminar",
          cancelButtonText: "No, Cancelar"
        })
        .then(result => {
          if (result.value) {
            DirectorioService.delete(dir._id).then(response => {
              console.log(response);
              this.$emit("return-dir", dir.father);
            });
          }
        });
    },
    restoreDir(dir) {
      this.restoreMatDir(dir, true);
    },
    changeName(dir) {
      console.log(dir);
      var tree = dir.tree;
      this.$swal
        .fire({
          title: "Editar Nombre",
          text: "Edita el Nombre de la Carpeta",
          input: "text",
          inputPlaceholder: dir.name,
          inputAttributes: {
            autocapitalize: "off"
          },
          showCancelButton: true,
          confirmButtonText: "Cambiar",
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#285c4d",
          cancelButtonColor: "#aaa"
        })
        .then(result => {
          if (result.value) {
            var newTree = [];
            if (tree.length > 0) {
              tree.forEach(el => {
                if (el.name == dir.name) {
                  el.name = result.value;
                }
                newTree.push(el);
              });
            }
            let data = {
              query: { _id: dir._id },
              data: { name: result.value, tags: [result.value], tree: newTree }
            };
            DirectorioService.edit(data).then(response => {
              this.$emit("return-dir", dir.father);
            });
          }
        });
    },
    removeMat(mtls) {
      this.$swal
        .fire({
          text: "¿Está Seguro de Eliminar el Material?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#285c4d",
          cancelButtonColor: "#aaa",
          confirmButtonText: "Sí, Eliminar",
          cancelButtonText: "No, Cancelar"
        })
        .then(result => {
          if (result.value) {
            MaterialService.delete(mtls._id).then(response => {
              console.log("RemoveMaterial: ", response);
              this.$emit("return-dir", mtls.father);
            });
          }
        });
    },
    restoreMat(mtls) {
      this.restoreMatDir(mtls, false);
    },
    restoreMatDir(element, isDir) {
      console.log("Element: ", element, "isDir: ", isDir);

      this.$swal
        .fire({
          text: "¿Desea Restaurar el Elemento?",
          type: "warning",
          showCancelButton: true,
          cancelButtonText: "No, Cancelar",
          confirmButtonText: "Si, Restaurar",
          confirmButtonColor: "#285c4d",
          cancelButtonColor: "#aaa"
        })
        .then(result => {
          if (result.value) {
            console.log("Result modal: ", result.value);
            if (isDir)
              DirectorioService.restore(element._id).then(response => {
                this.$emit("return-dir", element.father);
              });
            else
              MaterialService.restore(element._id).then(response => {
                console.log("Response RestoreMat: ", response);
                this.$emit("return-dir", element.father);
              });
          }
        });
    },
    changeNameMat(mtls) {
      this.$swal
        .fire({
          title: "Editar Nombre",
          text: "Edita el Nombre del Material",
          input: "text",
          inputPlaceholder: mtls.name,
          inputAttributes: {
            autocapitalize: "off"
          },
          showCancelButton: true,
          confirmButtonText: "Cambiar",
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#285c4d",
          cancelButtonColor: "#aaa"
        })
        .then(result => {
          if (result.value) {
            let data = {
              query: { _id: mtls._id },
              data: { name: result.value }
            };
            MaterialService.edit(data).then(response => {
              this.$emit("return-dir", mtls.father);
            });
          }
        });
    },
    editarMat(material) {
      /*console.log(material);
      let infoMaterial =  JSON.parse(JSON.stringify(material));
      delete infoMaterial.content;
      this.$store.dispatch('constructor/setInfo', infoMaterial); 
      this.$store.dispatch('constructor/updateOrders', material.content); */
      this.$router.push({
        name: "Editar Material",
        params: { id: material._id }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.title-header-collapse {
  cursor: pointer;
}
.item-list-view {
  border-radius: 10px;
  padding: 5px;
  margin: 5px;
  cursor: pointer;
  &:hover {
    background-color: rgba(218, 235, 241, 0.5);

    .icon-options-item {
      visibility: initial;
    }
  }
  svg,
  span {
    text-align: center;
    //margin-right: 20px;
  }
}
.icon-options-item {
  visibility: hidden;
  position: absolute;
  right: 5px;
}

.icon-dir {
  display: block;
  margin: auto;
  font-size: 4rem;
  color: #30a8d8;
}

.empty-folder {
  margin-top: 6rem;

  svg,
  p {
    text-align: center;
    color: #c8ced2;
  }

  p {
    font-size: 1.2rem;
    font-weight: bold;
  }
}
.d-block {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>